import * as path from "path";

import { httpGet } from "../../../Commons/HttpServer/AttributeRouting/Methods";
import { httpReturn } from "../../../Commons/HttpServer/AttributeRouting/Results";
import {
    FileStreamResult,
    StreamReturnResult,
} from "../../../Commons/HttpServer/AttributeRouting/Results/StreamResultHandler";
import { SingletonController } from "../../../Commons/HttpServer/ExpressWrapper/SingletonController";

export class BuildServerPrebuiltResourcesController extends SingletonController {
    @httpGet("/public/scripts/polyfill.min.js", httpReturn.StreamWithMime("application/javascript"))
    public async getPolyfillMin(): Promise<StreamReturnResult> {
        return new FileStreamResult(path.join(__dirname, "../../../StaticFilesForResourcesDir/polyfill.min.js"));
    }
}
